import React from 'react';

// Utils
import { ccyFormat } from '../../utils/currencyFormatter';

// Typography
import { Body2, H6, Body3 } from '../../themes/typography';

// CSS styles
import '../../styles/components/BookingBreakup.css';

const bookingBreakup = [
    {
        ticketName: 'AI Innovations Student Premium Pass Ticket ',
        charges: '2%',
        quantity: 5,
        totalPrice: 150,
        total: 150
    },
    {
        ticketName: 'Live Disco Music Concert Extravaganza Fest 2024',
        charges: '₹10 / Ticket',
        quantity: 10,
        totalPrice: 150,
        total: 150
    },
    {
        ticketName: 'Full-Stack Web Development Bootcamp Student Only',
        charges: '2%',
        quantity: 254,
        totalPrice: 150,
        total: 150
    },
    {
        ticketName: 'Digital Marketing Strategies for 2025',
        charges: '₹10 / Ticket',
        quantity: 365,
        totalPrice: 150,
        total: 150
    }
];

const taxBreakup = [
    {
        taxName: 'CGST @ 9%',
        taxAmount: '₹1500'
    },
    {
        taxName: 'SGST @ 9%',
        taxAmount: '₹1500'
    },
    {
        taxName: 'IGST @ 18%',
        taxAmount: '₹1500'
    }
];

export default function BookingBreakup({
    feesNote = true,
    grossTotalTitle = 'Gross Total',
    grossTotalValue = ccyFormat(1599),
    bookingFeesTitle = 'Booking Fee',
    bookingFeesValue = ccyFormat(1599),
    firstColumnTitle = 'Description',
    secondColumnTitle = 'Charges',
    thirdColumnTitle = 'Quantity',
    fourthColumnTitle = 'Ticket Price',
    fifthColumnTitle = 'Total',
    bookingFeesDetails = bookingBreakup,
    tax = taxBreakup,
    lightMode = false
}) {
    const color = lightMode ? '#11203A' : '#f5f5f5';

    function conditionallyRenderFeesNote() {
        return (
            <div className="booking-fees-notes-container">
                <Body2 color={color}>Fees:</Body2>
                <div className="booking-fees-notes-list">
                    <ul className="ul-list-section">
                        <li>
                            <Body3 color={color}>
                                1. ₹10 per Ticket on tickets priced up to ₹500.
                            </Body3>
                        </li>
                        <li>
                            <Body3 color={color}>
                                2. 2% per Ticket on tickets priced greater than ₹500.
                            </Body3>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {/* Main Container */}
            <div className="booking-breakup-container">
                {/* Booking Fees Breakup */}
                <table className="booking-fees-breakup-container">
                    {/* Table Columns */}
                    <thead>
                        <tr>
                            <th className="booking-desc-col">
                                <H6 color="#f5f5f5">{firstColumnTitle}</H6>
                            </th>
                            <th className="booking-charges-col">
                                <H6 color="#f5f5f5">{secondColumnTitle}</H6>
                            </th>
                            <th className="booking-qty-col">
                                <H6 color="#f5f5f5">{thirdColumnTitle}</H6>
                            </th>
                            <th className="booking-ttprice-col">
                                <H6 color="#f5f5f5">{fourthColumnTitle}</H6>
                            </th>
                            <th className="booking-total-col">
                                <H6 color="#f5f5f5">{fifthColumnTitle}</H6>
                            </th>
                        </tr>
                    </thead>

                    {/* Table Rows */}
                    <tbody>
                        {bookingFeesDetails.map((item, index) => (
                            <tr key={index}>
                                <td className="booking-desc-cell">
                                    <Body2
                                        color={color}
                                        style={{
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            width: '550px'
                                        }}
                                    >
                                        {item.ticketName}
                                    </Body2>
                                </td>
                                <td className="booking-charges-cell">
                                    <Body2 color={color}>{item.charges}</Body2>
                                </td>
                                <td className="booking-qty-cell">
                                    <Body2 color={color}>{item.quantity}</Body2>
                                </td>
                                <td className="booking-ttprice-cell">
                                    <Body2 color={color}>{ccyFormat(item.totalPrice)}</Body2>
                                </td>
                                <td className="booking-total-cell">
                                    <Body2 color={color}>{ccyFormat(item.total)}</Body2>
                                </td>
                            </tr>
                        ))}

                        {/* Empty Row */}
                        <tr>
                            <td colSpan={5} className="booking-empty-row"></td>
                        </tr>

                        {/* Booking Breakup Gross Total Section */}
                        <tr>
                            <td colSpan={3} className="booking-empty-colspan"></td>
                            <td className="booking-gross-title">
                                <Body2 color={color}>{grossTotalTitle}</Body2>
                            </td>
                            <td className="booking-gross-value">
                                <Body2 color={color}>{grossTotalValue}</Body2>
                            </td>
                        </tr>

                        {/* Booking Empty row */}
                        <tr>
                            <td colSpan={5} className="booking-empty-row"></td>
                        </tr>

                        {/* Booking Breakup Tax Section */}
                        <tr>
                            <td colSpan={3} className="booking-empty-colspan"></td>
                            <td colSpan={2} className="booking-tax-title">
                                <H6 color="#f5f5f5">Tax</H6>
                            </td>
                        </tr>

                        {/* Booking Breakup Tax Breakup Details Section */}
                        {tax.map((item, index) => {
                            const isLast = index === taxBreakup.length - 1;
                            return (
                                <tr key={index}>
                                    <td colSpan={3} className="booking-empty-colspan"></td>
                                    <td
                                        className="booking-tax-name"
                                        style={isLast ? { borderBottomLeftRadius: '5px' } : {}}
                                    >
                                        <Body2 color={color}>{item.taxName}</Body2>
                                    </td>
                                    <td className="booking-tax-amount">
                                        <Body2 color={color}>{ccyFormat(item.taxAmount)}</Body2>
                                    </td>
                                </tr>
                            );
                        })}

                        {/* Booking Empty Row */}
                        <tr>
                            <td colSpan={5} className="booking-empty-row"></td>
                        </tr>

                        {/* Booking Breakup Total Section */}
                        <tr>
                            <td colSpan={3} className="booking-empty-colspan"></td>
                            <td className="booking-gross-title">
                                <Body2 color={color}>{bookingFeesTitle}</Body2>
                            </td>
                            <td className="booking-gross-value">
                                <Body2 color={color}>{bookingFeesValue}</Body2>
                            </td>
                        </tr>

                        {/* Last Empty Row */}
                        <tr>
                            <td colSpan={5} className="booking-empty-row-last"></td>
                        </tr>
                    </tbody>
                </table>

                {/* Booking Fees Note */}
                {feesNote && conditionallyRenderFeesNote()}
            </div>
        </React.Fragment>
    );
}
